import customerEditComponent from './customer-edit.component';

const customerEditModule = angular.module('customerEdit', [
])
  .component('customerEdit', customerEditComponent)
  .name;

export default customerEditModule;
